<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-material-card
      icon="mdi-file-question-outline"
      :title="currentSubject.name"
      class="px-5 py-3"
    >
      <v-row>
        <v-btn color="red" class="ml-3" @click="deleteSelected()">o'chirish</v-btn>
        <v-spacer class="row"></v-spacer>
        <v-btn color="primary" @click="dialog = true">Import quiz</v-btn>
      </v-row>
      <v-data-table v-model="selected" :headers="headers" :items="items" item-key="id" show-select >
        <template v-slot:item.question="{ item }">
          <latex :text="item.question"></latex>
        </template>
        <template v-slot:item.answers0="{ item }">
          <latex :text="item.answers[0].content"></latex>
        </template>
        <template v-slot:item.answers1="{ item }">
          <latex :text="item.answers[1].content"></latex>
        </template>
        <template v-slot:item.answers2="{ item }">
          <latex :text="item.answers[2].content"></latex>
        </template>
        <template v-slot:item.answers3="{ item }">
          <latex :text="item.answers[3].content"></latex>
        </template>

      </v-data-table>
    </base-material-card>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <h1 style="color: #777">{{ indexItem === -1 ? "Yangi qo'shish" : "O'zgartirish" }}</h1>
          <v-spacer />
          <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <a :href="`${publicPath}question.csv`" style="text-decoration: none" download>
            <v-btn color="cyan" small>download example</v-btn>
          </a>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="12">
                <base-material-alert color="info" dark>
                  <span>FAN - {{currentSubject.name}}</span>
                </base-material-alert>
              </v-col>
              <v-col cols="12" md="12">
                <v-file-input
                  v-model="payload.file"
                  outlined
                  label="File(csv)"
                  accept=".csv"
                  :rules="ruleFile"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="text-center container">
          <v-btn text @click="closeModal">Cancel</v-btn>
          <v-spacer />
          <v-btn color="success" :disabled="!valid" @click="uploadItems()">Import</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import service from "../../service/Quiz.service";
import subjectService from "../../service/Subject.service";
import Latex from "@/components/Latex";

export default {
  name: "QuizTable",
  components: {Latex},
  data() {
    return {
      file: {},
      valid: true,
      ruleFile: [
        value =>
          !value ||
          value.size < 10000000 ||
          "Avatar size should be less than 2 MB!",
      ],
      rule: [v => !!v || "To'ldirilmagan"],
      search: {
        name: "",
        groupId: "",
        subjectId: "",
      },
      selected: [],
      dialog: false,
      headers: [
        {
          text: "Savol",
          width: "40%",
          align: "start",
          value: "question",
          divider: true,
        },
        {
          text: "",
          value: "answers0",
          align: "center",
          width: "15%",
          divider: true,
        },
        {
          text: "",
          value: "answers1",
          align: "center",
          width: "15%",
          divider: true,
        },
        {
          text: "",
          value: "answers2",
          align: "center",
          width: "15%",
          divider: true,
        },
        {
          text: "",
          value: "answers3",
          align: "center",
          width: "15%",
          divider: true,
        },
      ],
      items: [],
      payload: {
        file: null,
        subjectId: "",
        groupId: "",
      },
      defaultPayload: {
        file: null,
        subjectId: "",
      },
      editedItem: {
        id: "",
        question: "",
        subjectId: "",
        subjectName: "",
        answers: [],
      },
      defaultItem: {
        id: "",
        question: "",
        subjectId: "",
        subjectName: "",
        answers: [],
      },
      currentSubject: {
        id: "",
        name: "",
      },
      indexItem: -1,
      jwt: "",
      publicPath: process.env.BASE_URL,
    };
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
      this.jwt = this.$store.getters.jwt;
      service
        .getBySubject(this.$route.params.id, this.jwt)
        .then(res => {
          this.items = res.data;
        })
        .catch(err => {
          alert(err);
        });
      subjectService
        .getOne(this.$route.params.id, this.jwt)
        .then(res => {
          this.currentSubject = res.data;
        })
        .catch(err => {
          alert(err);
        });
    },
    uploadItems() {
      service
        .upload(this.payload.file, this.currentSubject.id, this.jwt)
        .then(() => {
          this.initial();
          this.closeModal();
        })
        .catch(err => {
          alert(err);
          this.closeModal();
        });
    },
    deleteSelected() {
      confirm("Are you sure") &&
        this.selected.forEach(item => {
          const index = this.items.indexOf(item);
          this.items.splice(index, 1);
          service
            .delete(item.id, this.jwt)
            .then(() => {})
            .catch(err => {
              alert(err);
            });
        });
      this.selected = [];
    },
    closeModal() {
      this.initial();
      this.indexItem = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = false;
      this.resetValidation();
      this.payload = Object.assign({}, this.defaultPayload);
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style scoped></style>
